const breakpoints = ["40em", "52em", "64em"];
const fontSizes = [11, 12, 14, 16, 20, 24, 32, 48, 64, 72];
let space = [];

for (let i = 0; i < 37; i++) {
    space.push(i * 4);
}

const colors = {
    bookBG: "white"
};

export const theme = {
    breakpoints,
    colors,
    fontSizes,
    space
};



// WEBPACK FOOTER //
// ./src/theme.js